import { Component } from 'react'
import { connect } from 'react-redux'
import { userLogout } from 'Reducers/Auth/actions'
import { PATHS } from 'Config/Routing/paths'

class Logout extends Component {
  componentDidMount() {
    this.props.userLogout()
    this.props.history.push(PATHS.main.login)
  }

  render() {
    return null
  }
}

const mapStateToProps = () => ({})

export default connect(
  mapStateToProps,
  {
    userLogout,
  },
)(Logout)



// WEBPACK FOOTER //
// ./src/Containers/Auth/Logout/index.js